import {Layout} from "antd";
import {Navigate, useOutlet} from "react-router-dom";
import {useAuth, useLang, useTheme} from "../../hooks";
import React, {useEffect} from "react";
import {fetchUserProfileAction, getMenuAction} from "../../store/pages/profile/actions";
import {useDispatch} from "react-redux";
import {StyledLayout} from "./Layout.styles";
import {ROUTE_PATH} from "../../constants";

export const DefaultProtectedLayout = () => {
  const outlet = useOutlet()
  const {isAuth} = useAuth()
  const dispatch = useDispatch()
  const {theme} = useTheme()
  const {lang} = useLang()


  useEffect(() => {
    if (isAuth) {
      dispatch(fetchUserProfileAction())
      dispatch(getMenuAction())
    }
  }, [])

  if (!isAuth) {
    return <Navigate to={ROUTE_PATH.AUTH} replace={true}/>
  }

  return (
    <StyledLayout className={`theme-${theme}`} lang={lang}>
      <Layout style={{maxHeight: "100vh", overflow: 'hidden'}}>
        <Layout.Content style={{overflowY: 'scroll'}} >
          {outlet}
        </Layout.Content>
      </Layout>
    </StyledLayout>
  )
}